import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

const IS_FORCE_ENABLED = false;

if (
  typeof window !== 'undefined' &&
  (process.env.APP_STAGE === 'production' || IS_FORCE_ENABLED)
) {
  // console.log('====== LOADING POSTHOG ======');
  posthog.init(process.env.POSTHOG_KEY!, {
    api_host: process.env.POSTHOG_API_HOST!,
    ui_host: process.env.POSTHOG_UI_HOST!,
    // Enable debug mode in development
    loaded: (posthog) => {
      if (process.env.NODE_ENV === 'development') posthog.debug();
    },
  });
}

export { PostHogProvider };

export default posthog;
